import { EfxClientPagedDataSource } from "@signal/component-library/efx-data-table";

export class EfxPagedAndSortingDataSource extends EfxClientPagedDataSource {
  sortingField: string | undefined = "";
  sortingDirection: string | undefined = "asc";
  override query() {
    if (this.cache) {
      this.cache = this.sortTheCache(this.cache);
    }
    super.query();
  }

  sortTheCache(data: any[]): any[] {
    const newData = [...data];
    Object.keys(this.currentSort).forEach((fieldName: string, index) => {
      this.sortingField = fieldName;
      this.sortingDirection = this.currentSort[fieldName];
    });
    if (this.sortingField && this.sortingDirection) {
      newData.sort(this.compareFn.bind(this));
    }
    return newData;
  }

  compareFn(a: any, b: any) {
    if (this.sortingField) {
      if (a[this.sortingField] === null) {
        return 1;
      }
      if (b[this.sortingField] === null) {
        return -1;
      }
      if (a[this.sortingField] < b[this.sortingField]) {
        return this.sortingDirection === "asc" ? -1 : 1;
      }
      if (a[this.sortingField] > b[this.sortingField]) {
        return this.sortingDirection === "asc" ? 1 : -1;
      }
    }
    return 0;
  }
}
